import { useParams } from "@tanstack/react-router";
import { Flex } from "antd";

import { FormView, SubEntityLayout } from "#layouts";

import styles from "./Patient.module.scss";
import { patientSubNavItems } from "./patientSubNavItems";

export const PatientDetail = () => {
	const { patientID } = useParams({ strict: false });
	const isCreateMode = patientID === "create";

	return (
		<Flex vertical flex={1} className={styles.detail}>
			{isCreateMode ? (
				<FormView entity="patient" mode="create" />
			) : (
				<SubEntityLayout
					parentScope={`patient-${patientID}`}
					basePath={`/patient/${patientID}`}
					subEntities={patientSubNavItems}
				/>
			)}
		</Flex>
	);
};
